import React from 'react';
import { Grid, Button, Dropdown, Form } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';

const statusOptions = [
  { key: 'active', text: 'Active', value: 1 },
  { key: 'inactive', text: 'Inactive', value: 0 }
];

const UpdateMVForm = ({
  loading,
  disabled,
  mvCodesDD,
  onChangeOfMVId,
  submitLoading,
  handleSubmit,
  manufacturersDD,
  variantsDD,
  onChangeOfMrp,
  onChangeOfOfferPrice,
  onChangeOfVendorPrice,
  onChangeOfManufacturerId,
  onChangeOfVariantId,
  selectedManufacturer,
  selectedVariant,
  mrp,
  vendorPrice,
  offerPrice,
  isActive,
  onChangeOfStatus
}) => (
  <Grid centered style={{ marginTop: '0px', padding: '10vh' }}>
    <Helmet>
      <title> Update Manufacturer Variant </title>
    </Helmet>
    <Grid.Row centered>
      <Grid.Column width={5}>
        <h2
          style={{
            fontWeight: 400,
            marginBottom: '1em',
            border: '1px solid #555',
            textAlign: 'center',
            color: '#555',
            padding: '0.5em'
          }}
        >
          Update Manufacturer Variant
        </h2>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row loading={loading}>
      <Grid.Column width={8}>
        <Form>
          <Form.Field required>
            <label>Select Manufacturer Variant</label>
            <Dropdown
              placeholder="Select Manufacturer Variant"
              loading={loading}
              selection
              search
              options={mvCodesDD}
              onChange={onChangeOfMVId}
            />
          </Form.Field>
          <Form.Field required>
            <label>Select Manufacturer</label>
            <Dropdown
              placeholder="Select Manufacturer"
              loading={loading}
              selection
              search
              value={selectedManufacturer}
              options={manufacturersDD}
              onChange={onChangeOfManufacturerId}
              disabled={disabled}
            />
          </Form.Field>
          <Form.Field required>
            <label>Select Variant</label>
            <Dropdown
              placeholder="Select Variant"
              loading={loading}
              selection
              search
              value={selectedVariant}
              options={variantsDD}
              onChange={onChangeOfVariantId}
              disabled={disabled}
            />
          </Form.Field>
          <Form.Field required>
            <label>MRP (in Rs.)</label>
            <input placeholder="50" value={mrp} onChange={onChangeOfMrp} disabled={disabled} />
          </Form.Field>
          <Form.Field required>
            <label>Offer Price (in Rs.)</label>
            <input
              placeholder="40"
              value={offerPrice}
              onChange={onChangeOfOfferPrice}
              disabled={disabled}
            />
          </Form.Field>
          <Form.Field required>
            <label>Vendor Price (in Rs.)</label>
            <input
              placeholder="40"
              value={vendorPrice}
              onChange={onChangeOfVendorPrice}
              disabled={disabled}
            />
          </Form.Field>
          <Form.Field required>
            <label>Is Active</label>
            <Dropdown
              placeholder="Select Status"
              loading={loading}
              selection
              search
              value={isActive}
              options={statusOptions}
              onChange={onChangeOfStatus}
              disabled={disabled}
            />
          </Form.Field>

          <Button
            basic
            color="blue"
            style={{ float: 'right' }}
            disabled={submitLoading || disabled}
            loading={submitLoading}
            onClick={handleSubmit}
          >
            Update Manufacturer Variant
          </Button>
        </Form>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default UpdateMVForm;



// WEBPACK FOOTER //
// ./src/Modules/UpdateManufacturerVariant/component.jsx